module.exports = __webpack_public_path__ + "static/img/1.ffcebab.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/eng/1.png
// module id = 9K/v
// module chunks = 0